import React from 'react';
import styled from 'styled-components/macro';
import { colors } from '../../theme';
import { NavBrand } from '../../data/HeaderData';
import { Link } from 'react-router-dom';
import {Accordion} from '.';
import sidebarBackground from '../../assets/images/sidebar-background.png';

const SidebarWrapper = styled.div`
  color: ${colors.primary.black90};
  background: ${colors.white};
  transition: all 0.3s ease-in-out;
  width: 240px;
  height: 100%;
  position: fixed;
  left: 0px;
  z-index: 9;
  border-right: 1px solid ${colors.lightversion};
`;

const NavbarBrand = styled.div`
  display: block;
  vertical-align: middle;
  padding: 10px 13px;
  text-align: center;
  border-bottom: 2px solid ${colors.primary.yellow100};
`;

const BrandImage = styled.img`
  width: 86%;
`;

const LeftSidebarNav = styled.div`
  padding: 0px;

  .accordion-menu {
    padding: 0px;
  }

  .accordion-item {
    padding: 10px 10px;
  }

  .accordion-item a {
    color: ${colors.primary.black90};
    font-size: 16px;
  }
`;

export const Sidebar = (props) => {
  return (
    <SidebarWrapper>
      <NavbarBrand>
        <Link to={NavBrand?.url || ''}>
          <BrandImage src={NavBrand.logo.dark} />
        </Link>
      </NavbarBrand>

      <div className="sidebar-scroll-div">
        <LeftSidebarNav className="left-sidebar-nav">

          {/* Accordion */}
          <Accordion />
          
        </LeftSidebarNav>
      </div>
    </SidebarWrapper>
  );
};

Sidebar.defaultProps = {};
